// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"eae7c498","513":"d2ece690","787":"900d2732"}[chunkId] + ".chunk.js";
};